import urls from './urls';
import axios from 'axios';

class notificationSettingsApi {
  // constructor() {
  //   this.restClient = new RestClient();
  // }
  static patchNotificationSettings(params) {
    // Messages query MessageReceivePermission No
    // Views query MessageReceivePermission No
    // Likes query MessageReceivePermission No
    // Favourites query MessageReceivePermission No
    // Matches query bool No
    // RHPTeamMessages query bool No
    // {"Messages":"Anyone","Views":"Anyone","Likes":"Anyone","Favourites":"Anyone","Matches":false,"RHPTeamMessages":false}
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PUSH_NOTIFICATION_SETTINGS;
    // return this.restClient.execute(url, ApiMethod.PATCH, params).then(res => res);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }
  static patchEmailSettings(params) {
    // MatchReport query bool No
    // DateFinder query bool No
    // RHPTeamMessages query bool No
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.EMAIL_NOTIFICATION_SETTINGS;
    // return this.restClient.execute(url, ApiMethod.PATCH, params).then(res => res);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } }).then(res => res);
  }
}

export default notificationSettingsApi;
